<template>
  <section v-if="variants.v1 === variant">
    <div style="position: relative">
      <library-container :key="renderKey" class="tw-relative tw-z-10 tw-pt-12 md:tw-py-24">
        <div class="tw-mb-8">
          <library-title
            class="tw-text-3xl tw-font-semibold lg:tw-text-4xl"
            tag="h3"
            :text="vars.titleText"
          ></library-title>
        </div>
        <div
          v-for="(item, index) in items"
          :key="`client-testimonial-${index}`"
          class="tw-grid tw-grid-cols-12 tw-gap-y-8 md:tw-gap-x-16 md:tw-gap-y-0"
          :style="visibleIndex === index ? 'display: grid;' : 'display: none;'"
        >
          <div class="pxp-services-h-container tw-col-span-12 md:tw-col-span-7">
            <template v-if="vars.isPopupBool">
              <div
                class="pxp-cover pxp-animate-in tw-relative tw-z-10 tw-h-[496px] tw-w-full tw-rounded"
                :style="`background-image: url(${item.image}); `"
              >
                <div
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
                  @click="togglePopup(true)"
                >
                  <a class="pxp-video-section-trigger tw-cursor-pointer">
                    <span class="fa fa-play"></span>
                  </a>
                </div>
              </div>
            </template>
            <template v-else>
              <iframe
                class="tw-w-full tw-rounded md:tw-h-[496px]"
                style="aspect-ratio: 16/9"
                :src="item.video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </template>
          </div>
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-justify-end tw-gap-y-4 md:tw-col-span-5">
            <div class="tw-flex tw-gap-x-3">
              <span
                v-for="i in item.star_count"
                :key="`star-${i}`"
                class="fa fa-star tw-text-2xl"
                :style="`color: var(--camel)`"
              ></span>
            </div>
            <library-title tag="h4" :text="item.title" style="font-weight: 900"></library-title>
            <library-text :text="item.description"> </library-text>
            <library-text :text="item.author" style="color: #808080; font-weight: bold"></library-text>
            <div class="tw-mt-8 tw-pl-6" @click="goNextOne()">
              <div
                class="pxp-areas-carousel-right-arrow pxp-animate"
                style="opacity: 1 !important; position: static !important"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="32.414" height="20.828" viewBox="0 0 32.414 20.828">
                  <g id="Symbol_1_1" data-name="Symbol 1 – 1" transform="translate(-1847.5 -1589.086)">
                    <line
                      id="Line_2"
                      data-name="Line 2"
                      x2="30"
                      transform="translate(1848.5 1599.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                    <line
                      id="Line_3"
                      data-name="Line 3"
                      x2="9"
                      y2="9"
                      transform="translate(1869.5 1590.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                    <line
                      id="Line_4"
                      data-name="Line 4"
                      y1="9"
                      x2="9"
                      transform="translate(1869.5 1599.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </library-container>
      <div
        class="tw-absolute tw-top-0 tw-z-0 tw-mt-10 tw-hidden tw-h-[260px] tw-w-full md:tw-bottom-0 md:tw-left-0 md:tw-top-[unset] md:tw-block md:tw-h-[406px] md:tw-w-[330px] lg:tw-mt-0 lg:tw-w-[530px]"
        style="background-color: var(--purple)"
      ></div>
    </div>
  </section>

  <section v-if="variants.v2 === variant" class="tw-py-10 lg:tw-py-16">
    <div class="container">
      <h3 class="tw-mb-10">{{ vars.titleText }}</h3>
      <div class="tw-w-full">
        <div
          v-for="(item, index) in items"
          :key="`client-testimonial-${index}`"
          class="tw-grid tw-grid-cols-12 tw-gap-y-4 md:tw-gap-x-16 md:tw-gap-y-0"
          :style="visibleIndex === index ? 'display: grid;' : 'display: none;'"
        >
          <div
            class="pxp-services-h-container tw-col-span-12 tw-mb-6 tw-w-full md:tw-col-span-7"
            style="aspect-ratio: 16/9"
          >
            <div v-if="vars.isPopupBool">
              <div
                class="pxp-cover pxp-animate-in tw-relative tw-z-10 tw-h-[496px] tw-w-full tw-rounded"
                :style="`background-image: url(${item.image}); `"
              >
                <div
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
                  @click="togglePopup(true)"
                >
                  <a class="pxp-video-section-trigger tw-cursor-pointer">
                    <span class="fa fa-play"></span>
                  </a>
                </div>
              </div>
            </div>
            <div v-else class="tw-w-full" style="aspect-ratio: 16/9">
              <iframe
                class="tw-relative tw-w-full"
                style="aspect-ratio: 16/9"
                :src="item.video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-justify-end tw-gap-y-4 md:tw-col-span-5">
            <div class="tw-flex tw-gap-x-3">
              <span v-for="i in item.star_count" :key="`star-${i}`"
                ><svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.76406 25.3333L7.93073 15.9667L0.664062 9.66667L10.2641 8.83333L13.9974 0L17.7307 8.83333L27.3307 9.66667L20.0641 15.9667L22.2307 25.3333L13.9974 20.3667L5.76406 25.3333Z"
                    fill="#90C73D"
                  />
                </svg>
              </span>
            </div>
            <h4>{{ item.title }}</h4>
            <p>{{ item.description }}</p>
            <span>{{ item.author }}</span>
            <div class="tw-mt-8 tw-pl-6" @click="goNextOne()">
              <div
                class="pxp-areas-carousel-right-arrow pxp-animate"
                style="opacity: 1 !important; position: static !important"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="32.414" height="20.828" viewBox="0 0 32.414 20.828">
                  <g id="Symbol_1_1" data-name="Symbol 1 – 1" transform="translate(-1847.5 -1589.086)">
                    <line
                      id="Line_2"
                      data-name="Line 2"
                      x2="30"
                      transform="translate(1848.5 1599.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                    <line
                      id="Line_3"
                      data-name="Line 3"
                      x2="9"
                      y2="9"
                      transform="translate(1869.5 1590.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                    <line
                      id="Line_4"
                      data-name="Line 4"
                      y1="9"
                      x2="9"
                      transform="translate(1869.5 1599.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section v-if="variants.v3 === variant" class="tw-py-10 lg:tw-py-16">
    <div class="container">
      <h3 class="tw-mb-10">{{ vars.titleText }}</h3>
      <div class="tw-w-full">
        <div
          v-for="(item, index) in items"
          :key="`client-testimonial-${index}`"
          class="tw-grid tw-grid-cols-12 tw-gap-y-4 md:tw-gap-x-16 md:tw-gap-y-0"
          :style="visibleIndex === index ? 'display: grid;' : 'display: none;'"
        >
          <div
            class="pxp-services-h-container tw-col-span-12 tw-mb-6 tw-w-full md:tw-col-span-7"
            style="aspect-ratio: 16/9"
          >
            <div v-if="vars.isPopupBool">
              <div
                class="pxp-cover pxp-animate-in tw-relative tw-z-10 tw-h-[496px] tw-w-full tw-rounded"
                :style="`background-image: url(${item.image}); `"
              >
                <div
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
                  @click="togglePopup(true)"
                >
                  <a class="pxp-video-section-trigger tw-cursor-pointer">
                    <span class="fa fa-play"></span>
                  </a>
                </div>
              </div>
            </div>
            <div v-else class="tw-w-full" style="aspect-ratio: 16/9">
              <iframe
                class="tw-relative tw-w-full"
                style="aspect-ratio: 16/9"
                :src="item.video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-justify-end tw-gap-y-4 md:tw-col-span-5">
            <div class="tw-flex tw-gap-x-3">
              <span v-for="i in item.star_count" :key="`star-${i}`"
                ><svg width="28" height="26" viewBox="0 0 28 26" fill="#E7DFBA" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.76406 25.3333L7.93073 15.9667L0.664062 9.66667L10.2641 8.83333L13.9974 0L17.7307 8.83333L27.3307 9.66667L20.0641 15.9667L22.2307 25.3333L13.9974 20.3667L5.76406 25.3333Z"
                    fill="#E7DFBA"
                  />
                </svg>
              </span>
            </div>
            <h5>{{ item.title }}</h5>
            <p>{{ item.description }}</p>
            <h6>{{ item.author }}</h6>
            <div class="tw-mt-8 tw-pl-6" @click="goNextOne()">
              <div
                class="pxp-areas-carousel-right-arrow pxp-animate"
                style="opacity: 1 !important; position: static !important"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="32.414" height="20.828" viewBox="0 0 32.414 20.828">
                  <g id="Symbol_1_1" data-name="Symbol 1 – 1" transform="translate(-1847.5 -1589.086)">
                    <line
                      id="Line_2"
                      data-name="Line 2"
                      x2="30"
                      transform="translate(1848.5 1599.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                    <line
                      id="Line_3"
                      data-name="Line 3"
                      x2="9"
                      y2="9"
                      transform="translate(1869.5 1590.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                    <line
                      id="Line_4"
                      data-name="Line 4"
                      y1="9"
                      x2="9"
                      transform="translate(1869.5 1599.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <library-popups-video-popup
    v-if="vars.isPopupBool"
    v-model:is-visible="isPopupVisible"
    :video-url="visibleTestimonial.video"
  />
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { produceKey } from '~/server/core/helpers';
import { jQuery } from '~/public/theme3/js/vendor/custom';

export default defineNuxtComponent({
  name: 'Theme3ClientTestimonials',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
      isPopupVisible: false,
      visibleIndex: 0,

      renderKey: produceKey(),
    };
  },

  computed: {
    visibleTestimonial() {
      return this.items[this.visibleIndex];
    },

    items() {
      return this.groupedVariables.items;
    },
  },

  methods: {
    togglePopup(status = false) {
      this.isPopupVisible = status;
    },

    goNextOne() {
      if (this.items.length !== this.visibleIndex + 1) {
        this.visibleIndex += 1;
      } else {
        this.visibleIndex = 0;
      }
      this.renderKey = produceKey();
      this.$nextTick(() => {
        jQuery.runAnimation();
      });
    },
  },
});
</script>
